let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k3XCC")).then(() => parcelRequire('03p3V'));